module.exports = __webpack_public_path__ + "static/team-14-4ecf5e654bdb7d80e0474e0cad890b8f.jpg";